import shave from 'shave';
import PerfectScrollbar from 'perfect-scrollbar';
const EventEmitter = require('eventemitter3');

/* clamp.js обрезает строки по высоте */

// const clamp = require('./clamp');

/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-escape */
let isMobile = false; 
if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) 
    || (/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i).test(navigator.userAgent.substr(0, 4))) {isMobile = true;}
/* eslint-enable no-unused-vars */
/* eslint-enable no-useless-escape */

const body = document.body;
const textCont = [...document.querySelectorAll('.js--duo .text-block__container')];
const textSections = [...document.querySelectorAll('.section--duo')];
const shadowBlock = document.querySelector('.shadow-block');
const emitter = new EventEmitter();

let cropedContainerSize = 230;



let ps;

const getWinDimention = vector => {
    if (vector === 'w') {
        return Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
    } else if (vector === 'h') {
        return Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
    }
}



const collapseTextBlock = parentContainer => {
    const container = parentContainer.querySelector('.expanded');

    function collapseText() {
        body.removeAttribute('text-expanded', '');
        ps.destroy();
        ps = null;
        container.classList.remove('expanded');
        container.parentNode.parentNode.classList.remove('expanded');
        shadowBlock.classList.remove('shadow-block--show-shadow');
        container.parentNode.parentNode.parentNode.querySelector('.text-block--one').classList.remove('hide');
        container.parentNode.parentNode.parentNode.querySelector('.text-block--two').classList.remove('hide');
    }
    window.dispatchEvent(new window.Event('coverPicture'));
    window.dispatchEvent(new window.Event('hideAlternativePicture'));
    emitter.emit('collapsed');
    setTimeout(collapseText, 100);
}

const expandTextBlock = container => {

    const label = container.parentNode.parentNode.dataset.label;

    function expandText() {
        ps = new PerfectScrollbar(container.parentNode);    
        container.parentNode.scrollTop = 0; 
        shadowBlock.classList.add('shadow-block--show-shadow');
        container.classList.add('expanded');
        container.parentNode.parentNode.classList.add('expanded');
        if (container.parentNode.parentNode.classList.contains('text-block--one')) {
            container.parentNode.parentNode.parentNode.querySelector('.text-block--two').classList.add('hide');
            body.setAttribute('text-expanded', '1');
            window.dispatchEvent(new window.Event('hideAlternativePicture'));
        } else {
            container.parentNode.parentNode.parentNode.querySelector('.text-block--one').classList.add('hide');
            body.setAttribute('text-expanded', '2');
            window.dispatchEvent(new window.Event('showAlternativePicture'));
        }
    }
    window.dispatchEvent(new window.Event('revealPicture'));
    emitter.emit('expanded', label);
    setTimeout(expandText, 100);
}

const textBlock = {

    construct() {

    const windowHeight = getWinDimention('h');
    const windowWidth = getWinDimention('w');
    cropedContainerSize = windowHeight < windowWidth ? Math.ceil(windowHeight / 5) : Math.ceil(windowWidth / 5);

    
    const _setData = () => {
        textCont.forEach(container => {
            container.data = {
                contH3: container.querySelector('h3').innerHTML,
                contPar: container.querySelector('p').innerHTML
            }
        })
    }
    _setData();

    const addCloseButtonListeners = () => {
        const bloseButtons = [...document.querySelectorAll('.close-button')];
        bloseButtons.forEach(button => {
            button.addEventListener('click', () => {
                textSections.forEach(section => {
                        if (section.classList.contains('active')) {
                        collapseTextBlock(section.querySelector('.ps'))
                    }
                })
            })  
        })
    }


    textCont.forEach(container => {
        const contentHeader = container.querySelector('h3');
        if (container.data.contH3 === null) {return;}
        const contentParagraphs = [...container.querySelectorAll('p')];
        const contentFirstParagraph = contentParagraphs.shift();
        const pictureNameContainer = container.querySelector('span');

        const shortTextContainer = document.createElement('div');
        shortTextContainer.classList.add('short-text');
        shortTextContainer.appendChild(contentHeader);
        shortTextContainer.appendChild(contentFirstParagraph);
        
        const longTextContainer = document.createElement('div');
        longTextContainer.classList.add('long-text');

        longTextContainer.appendChild(contentHeader.cloneNode(true));
        longTextContainer.appendChild(contentFirstParagraph.cloneNode(true));
        if (contentParagraphs.length > 1) {
            contentParagraphs.forEach(paragraph => {
                longTextContainer.appendChild(paragraph);
            })
        } else {
            longTextContainer.appendChild(contentParagraphs[0]);
        }

        /* add close button */
        const closeTextBlockContainer = document.createElement('div');
        closeTextBlockContainer.classList.add('close-button');
        closeTextBlockContainer.innerHTML = 'ЗАКРЫТЬ';
        longTextContainer.appendChild(closeTextBlockContainer);
        
        container.innerHtml = '';
        if (pictureNameContainer) {
            shortTextContainer.appendChild(pictureNameContainer);
        }
        container.appendChild(shortTextContainer);

        
        
        container.appendChild(longTextContainer);
        const firstParagraph = container.querySelector('p');
        shave(firstParagraph, cropedContainerSize);     
    })

    addCloseButtonListeners();

    },

    
    reinit() {
        const windowHeight = getWinDimention('h');
        const windowWidth = getWinDimention('w');
        cropedContainerSize = windowWidth > windowHeight ? Math.ceil(windowHeight / 5) : Math.ceil(windowWidth / 5);
        textCont.forEach(container => {
            const shortParagraph = container.querySelector('.short-text p');
            shortParagraph.innerHTML = container.data.contPar;
            shave(shortParagraph, cropedContainerSize);
        })
    }
}

/* resize event with timeout */

let resizeTimeout;
const resizeDelta = 30;
const resizeTimeoutCount = 400;
let winHeight = getWinDimention('h');
let winWidth = getWinDimention('w');
let newWinHeight, newWinWidth;

const checkDelta = (newDim, oldDim) => {
    // console.log(Math.abs(newDim - oldDim))
    if (Math.abs(newDim - oldDim) > resizeDelta) {
        return true;
    } else {
        return false;
    }
}

const reInitTextContainers = () => {
    newWinHeight = getWinDimention('h');
    newWinWidth = getWinDimention('w');
    if (checkDelta(newWinHeight, winHeight) || checkDelta(newWinWidth, winWidth)) {
        winHeight = getWinDimention('h');
        winWidth = getWinDimention('w');
        textBlock.reinit();
        return;
    }
    winHeight = getWinDimention('h');
    winWidth = getWinDimention('w');    
}

const resizeThrottler = () => {
    if (!resizeTimeout) {
      resizeTimeout = setTimeout(function () {
        resizeTimeout = null;
        reInitTextContainers();
       }, resizeTimeoutCount);
    }
  }

window.addEventListener('resize', resizeThrottler, false);




textCont.forEach(container => {
    container.addEventListener('click', () => {
        if (!container.classList.contains('expanded')) {
             expandTextBlock(container);
         }
    });
    container.addEventListener('mouseover', () => {
        if (container.classList.contains('expanded')) return;
        if (container.parentNode.parentNode.classList.contains('text-block--one')) {
            window.dispatchEvent(new window.Event('hideAlternativePicture'));
        } else {
            window.dispatchEvent(new window.Event('showAlternativePicture'));
        }
    });
    container.addEventListener('mouseout', () => {
        if (container.classList.contains('expanded')) return;
        window.dispatchEvent(new window.Event('hideAlternativePicture'));

    });
})

/*
body.addEventListener('click', e => {
    if (body.hasAttribute('text-expanded')) {
        if (e.target.classList.contains('expanded') || e.target.parentNode && e.target.parentNode.classList.contains('expanded') || e.target.parentNode.parentNode && e.target.parentNode.parentNode.classList.contains('expanded') || e.target.parentNode.parentNode.parentNode && e.target.parentNode.parentNode.parentNode.classList.contains('expanded'))
            return;
        textSections.forEach(section => {
            if (section.classList.contains('active')) {
                collapseTextBlock(section.querySelector('.ps'))
            }
        })
    }
})
*/

const closeCrosses = [...document.querySelectorAll('.close-cross')];

closeCrosses.forEach(cross => {
    cross.addEventListener('click', () => {
        textSections.forEach(section => {
                if (section.classList.contains('active')) {
                collapseTextBlock(section.querySelector('.ps'))
            }
        })
    })  
})

const _init = () => {
    textBlock.construct();
}

emitter.init = _init;
module.exports = emitter;


// WEBPACK FOOTER //
// ./js/viscom/vereschagin/TextBlocks.js